<template>
  <div>
    <v-dialog v-model="show">
      <v-card>
        <v-card-title>
          <h2>{{editedIndexReceiveOrder > -1 ? 'Edit receive order ' + receivingOrder.id : 'New receive order'}}</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="show=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container container--fluid grid-list-xl pb-0>
            <v-form
              ref="form"
              v-model="valid">
              <v-row justify="space-between">
                <v-col md="3" cols="12">
                  <div v-if="editedIndexReceiveOrder > -1" class="client-name">
                    <div style="font-size: 14px;">Client Name</div>
                    <div style="font-size: 18px;">{{receivingOrder.client_name ? receivingOrder.client_name : '-'}}</div>
                  </div>
                  <v-autocomplete v-else
                    :items="clients"
                    v-model="receivingOrder.client_id"
                    item-text="name"
                    item-value="id"
                    label="Pick a client..."
                    prepend-icon="fas fa-user"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col md="3" cols="12">
                  <v-dialog
                    ref="dialogDateReceiveOrder"
                    v-model="modalDateReceiveOrder"
                    :return-value.sync="receivingOrder.date"
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="receivingOrder.date"
                        label="Receiving date"
                        prepend-icon="event"
                        required
                        @click.native="modalDateReceiveOrder = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="receivingOrder.date"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="blue darken-1" @click="modalDateReceiveOrder = false">Cancel</v-btn>
                      <v-btn text color="blue darken-1"
                             @click="$refs.dialogDateReceiveOrder.save(receivingOrder.date)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
<!--                <v-col md="3" cols="12">-->
<!--                  <v-menu-->
<!--                    v-model="etaDialog"-->
<!--                    ref="etaDialog"-->
<!--                    offset-y-->
<!--                    :close-on-content-click="false"-->
<!--                    :return-value.sync="receivingOrder.eta"-->
<!--                  >-->
<!--                    <template v-slot:activator="{ on }">-->
<!--                      <v-text-field-->
<!--                        prepend-icon="access_time"-->
<!--                        v-model="receivingOrder.eta"-->
<!--                        readonly-->
<!--                        label="Estimated line haul arrival time"-->
<!--                        v-on="on"-->
<!--                      ></v-text-field>-->
<!--                    </template>-->
<!--                    <v-time-picker-->
<!--                      v-if="etaDialog"-->
<!--                      format="24hr"-->
<!--                      @click:minute="$refs.etaDialog.save(receivingOrder.eta)"-->
<!--                      :allowed-minutes="allowedMinutes"-->
<!--                      v-model="receivingOrder.eta"-->
<!--                    ></v-time-picker>-->
<!--                  </v-menu>-->
<!--                </v-col>-->
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="local_mall"
                    v-model="receivingOrder.number"
                    label="Reference number"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-select
                    label="Choose a depot"
                    :items="depots"
                    item-text="name"
                    item-value="id"
                    v-model="receivingOrder.depot_id"
                    prepend-icon="fas fa-warehouse"
                  ></v-select>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="person"
                    v-model="receivingOrder.sender_name"
                    label="Sender name"
                    required
                  ></v-text-field>
                </v-col>
<!--                <v-col md="3" cols="12">-->
<!--                  <v-text-field-->
<!--                    prepend-icon="place"-->
<!--                    v-model="receivingOrder.sender_address"-->
<!--                    label="Sender address"-->
<!--                    required-->
<!--                  ></v-text-field>-->
<!--                </v-col>-->
<!--                <v-col md="3" cols="12">-->
<!--                  <v-text-field-->
<!--                    prepend-icon="place"-->
<!--                    v-model="receivingOrder.sender_suburb"-->
<!--                    label="Sender suburb"-->
<!--                    required-->
<!--                  ></v-text-field>-->
<!--                </v-col>-->
<!--                <v-col md="3" cols="12">-->
<!--                  <v-text-field-->
<!--                    prepend-icon="place"-->
<!--                    v-model="receivingOrder.sender_state"-->
<!--                    label="Sender state"-->
<!--                    required-->
<!--                  ></v-text-field>-->
<!--                </v-col>-->
<!--                <v-col md="3" cols="12">-->
<!--                  <v-text-field-->
<!--                    prepend-icon="place"-->
<!--                    v-model="receivingOrder.sender_postcode"-->
<!--                    label="Sender postcode"-->
<!--                    required-->
<!--                  ></v-text-field>-->
<!--                </v-col>-->
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="local_mall"
                    v-model="receivingOrder.sender_reference"
                    label="Sender reference"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="emoji_transportation"
                    v-model="receivingOrder.carrier"
                    label="Carrier name"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="local_mall"
                    v-model="receivingOrder.carrier_reference"
                    label="Carrier reference"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="3" cols="12">
                  <v-text-field
                    prepend-icon="fas fa-pallet"
                    v-model="receivingOrder.num_pallets"
                    label="Total number of pallets to be received"
                    type="number"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-col md="3" cols="12">
                <v-switch
                  class="justify-center"
                  color="blue"
                  v-model="receivingOrder.exchange_pallets"
                  label="Exchange pallets"
                ></v-switch>
              </v-col>
            </v-form>
            <v-row justify="center" align="center" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
              <v-col cols="2" class="text-center">
                <v-btn
                  text
                  @click="$emit('close');$emit('updateDataTable');"
                  color="blue-grey lighten-2"
                >Cancel
                </v-btn>
              </v-col>
              <v-col cols="2" class="text-center">
                <v-btn
                  text
                  @click="$emit('save')"
                  color="blue darken-1"
                  :disabled="isSaved && editedIndexReceiveOrder === -1"
                >Save
                </v-btn>
              </v-col>
              <v-col cols="2" class="text-center" v-if="isSaved || editedIndexReceiveOrder > -1">
                <v-btn
                  text
                  @click="$emit('openItemsDialog')"
                  color="indigo"
                >Items
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog width="700px" v-model="showBis" style="z-index: 10">
      <v-card>
        <v-card-title>
          <h3>Receive Order Items</h3>
          <v-spacer></v-spacer>
          <v-tooltip top color="secondary">
            <template v-slot:activator="{ on }">
              <v-btn text large @click="updateDataTable" v-on="on">
                <v-icon color="cyan darken-2">refresh</v-icon>
              </v-btn>
            </template>
            <span>Refresh</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn fab small color="warning" v-on="on" class="elevation-2 align-center">
                <v-icon @click="newItem">add</v-icon>
              </v-btn>
            </template>
            <span>Add an item</span>
          </v-tooltip>
        </v-card-title>

        <v-divider color="#42a5f5"></v-divider>

        <v-col cols="12">
          <v-btn block @click="getExcel">
            Get Excel Template
          </v-btn>
        </v-col>

        <v-card color="#42424211" class="ma-4">
          <v-container class="py-0">
            <v-row align="center" justify="center" class="my-0">
              <v-col cols="9" md="4">
                <v-file-input
                  v-model="excelFile"
                  label="Items Upload"
                  hint="select a .xlsx file"
                  accept=".xlsx"
                ></v-file-input>
              </v-col>
              <v-col cols="2" md="2">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      :disabled="!excelFile"
                      color="primary"
                      class="ma-2 white--text"
                      @click="submitFile"
                      v-on="on"
                    >
                      <v-icon dark>fas fa-file-import</v-icon>
                    </v-btn>
                  </template>
                  <span>Submit excel</span>
                </v-tooltip>

              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-data-table
          :headers="headers"
          :items="renderedReceivingOrderItems"
          :loading="loading"
        >
          <template v-slot:item="props">
            <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
              <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headers" :key="index">
                {{props.item[header.value]}}
              </td>
              <td v-else class="text-center">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-icon color="red" @click="deleteRow(props.item)" v-on="on" class="pl-1">
                      delete
                    </v-icon>
                  </template>
                  <span>Delete</span>
                </v-tooltip>
              </td>

            </tr>
          </template>
        </v-data-table>
        <v-card-actions class="justify-center">
          <v-btn text color="blue-grey lighten-2" @click="$emit('closeItem')">
            Exit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="450px" v-model="addItemDialog">
      <v-card>
        <v-card-title>
          <h3>{{editedIndexItem > -1 ? 'Edit item No ' + editedItem.id + 'from receive order No ' + receivingOrder.id : 'Add an item to receive order No ' + receivingOrder.id }} </h3>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text>
          <v-row>
            <v-select
              label="Choose an item"
              :items="items"
              item-text="name"
              item-value="id"
              v-model="editedItem.item_id"
            ></v-select>
          </v-row>
          <v-row>
            <v-text-field
              label="Quantity"
              v-model="editedItem.quantity"
              type="number"
            ></v-text-field>
          </v-row>
          <v-row>
            <v-text-field
              label="Serial"
              v-model="editedItem.serial"
            ></v-text-field>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text color="red" @click="closeAddItemDialog">Cancel</v-btn>
          <v-btn text color="primary" @click="saveChanges">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete this item. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
          <v-btn text @click="DeleteItem" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
    import axios from 'axios';
    import Excel from 'exceljs/dist/exceljs';
    import {saveAs} from "file-saver";

    export default {
        name: "CreateReceiveOrder",
        props: {
            createReceiveOrderDialog: Boolean,
            receivingOrder: Object,
            itemsDialog: Boolean,
            editedIndexReceiveOrder: Number,
            isSaved: Boolean,
        },
        data() {
            return {
                valid: false,
                modalDateReceiveOrder: false,
                etaDialog: false,
                depots: null,
                clients: null,
                addItemDialog: null,
                editedIndexItem: -1,
                loading: false,
                items: null,
                headers: [
                    {text: 'Item ID', value: 'item_id', align: 'center', sortable: false},
                    {text: 'Name', value: 'name', align: 'center', sortable: false},
                    {text: 'Quantity', value: 'quantity', align: 'center', sortable: false},
                    {text: 'Serial', value: 'serial', align: 'center', sortable: false},
                    {text: 'Actions', value: 'actions', align: 'center', sortable: false}
                ],
                toBeDeleted: null,
                deleteDialog: false,
                editedItem: {
                    item_id	: null,
                    quantity: null,
                    serial: null,
                },
                default: {
                    item_id	: null,
                    quantity: null,
                    serial: null,
                },
                reload: false,

                excelFile: null,
                data: []
            }
        },
        mounted() {
            this.getDepots();
            this.getClients();
        },
        computed: {
            show: {
                get() {
                    return this.createReceiveOrderDialog;
                },
                set(value) {
                    if (!value) this.$emit('close');
                }
            },
            showBis: {
                get() {
                    return this.itemsDialog;
                },
                set(value) {
                    if (!value) this.$emit('closeItem');
                }
            },
            renderedReceivingOrderItems() {
                if (this.GetReceivingOrderItems === null || this.GetReceivingOrderItems === undefined) {
                    return [];
                } else {
                    return this.GetReceivingOrderItems;
                }
            },
        },
        methods: {
            allowedMinutes: v => !(v % 30),
            updateDataTable() {
                this.reload = !this.reload;
            },
            // @vuese
            // Gets all the depots
            getDepots() {
                axios.get(process.env.API_URL + '/depots?wms=true')
                    .then((response) => {
                        this.depots = response.data;
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Gets all the clients
            getClients() {
                axios.get(process.env.API_URL + '/clients?active=true')
                    .then((response) => {
                        this.clients = Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            // @vuese
            // Gets all the items
            getItems() {
                axios.get(process.env.API_URL + '/items?client=' + this.receivingOrder.client_id)
                    .then((response) => {
                        this.items =  Object.values(response.data).sort((a, b) => (a.name > b.name) ? 1 : -1);
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
            newItem() {
                this.editedIndexItem = -1;
                this.editedItem = Object.assign({}, this.default);
                this.addItemDialog = true;
                this.getItems();
            },
            editRow(item) {
                this.editedItem = Object.assign({}, item);
                this.editedIndexItem = this.renderedReceivingOrderItems.indexOf(item);
                this.addItemDialog = true;
                this.getItems();
            },
            deleteRow(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            DeleteItem() {
                axios.delete(process.env.API_URL + '/receivingorders/' + this.receivingOrder.id + '/items/' + this.toBeDeleted.id)
                    .then((response) => {
                        this.toBeDeleted = null;
                        this.deleteDialog = false;
                        this.updateDataTable();
                        this.$store.commit('displaySnackbar', "Delete successful");
                    })
                    .catch((error) => {
                        this.deleteDialog = false;
                        this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
                    });
                this.updateDataTable();
            },
            closeAddItemDialog() {
                this.editedIndexItem = -1;
                this.addItemDialog = false;
                this.editedItem = Object.assign({}, this.default);
            },
            saveChanges() {
                let body = {
                    item_id: this.editedItem.item_id,
                    quantity: this.editedItem.quantity,
                    serial: this.editedItem.serial,
                };

                if (this.editedIndexItem > -1) {
                    // EDIT
                    axios.put(process.env.API_URL + '/receivingorders/' + this.receivingOrder.id + '/items/' + this.editedItem.id, this.editedItem)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', 'Changes saved');
                            this.updateDataTable();
                        })
                        .catch((error) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        });
                } else {
                    // CREATE
                    if (body.quantity === null) {
                        this.$store.commit('displaySnackbar', 'Please enter a quantity');
                        return false;
                    }

                    axios.post(process.env.API_URL + '/receivingorders/' + this.receivingOrder.id + '/items', body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', 'Create item successful');
                            this.updateDataTable();
                        })
                        .catch((error) => {
                            this.$store.commit('displaySnackbar', 'ERROR: Create item failed');
                        });
                }
                this.closeAddItemDialog();
            },

            // @vuese
            // Read the excel file and trigger the saveChanges method
            readXLSX(){
              const reader = new FileReader();
              const wb = new Excel.Workbook();
              this.loading = true;

              reader.readAsArrayBuffer(this.excelFile);
              reader.onload = () => {
                const buffer = reader.result;
                // const itemExcelList = [];
                const idToTableItem = {};
                wb.xlsx.load(buffer).then(workbook => {
                  workbook.eachSheet((sheet, id) => {
                    sheet.eachRow((row, rowIndex) => {
                      if (rowIndex == 1){
                        row.values.forEach( (item, itemId) => {
                          idToTableItem[itemId] = item
                        });
                      } else {
                        const excelItem = {};
                        row.values.forEach( (item, itemId) => {
                          if (idToTableItem[itemId]){
                            excelItem[idToTableItem[itemId]] = item;
                          }
                        });

                        console.log(excelItem.quantity)
                        if (!isNaN(parseInt(excelItem.quantity))){
                          this.loading = true;
                          axios.get(process.env.API_URL + '/items?client=' + this.receivingOrder.client_id + '&&sku=' + excelItem['sku'])
                            .then((response) => {
                              excelItem['item_id'] = response.data[0].id;
                              console.log(excelItem);
                              const body = {
                                item_id: parseInt(excelItem.item_id),
                                quantity: parseInt(excelItem.quantity),
                                serial: excelItem.serial,
                              };
                              axios.post(process.env.API_URL + '/receivingorders/' + this.receivingOrder.id + '/items', body)
                                .then((response) => {
                                  this.$store.commit('displaySnackbar', 'Create item successful');
                                  this.loading = false;
                                  this.updateDataTable();
                                })
                                .catch((error) => {
                                  this.loading = false;
                                  this.$store.commit('displaySnackbar', 'ERROR: Create item failed on id: ' + body.item_id);
                                });
                            })
                            .catch((response) => {
                              this.loading = false;
                              this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                            })
                        } else {
                          this.loading = false;
                        }
                      }
                    });
                  });
                });
              }
            },
            async submitFile(){
              if (!this.excelFile) {
                this.$store.commit('displaySnackbar', 'No file selected');
                return;
              }

              const workbook = new Excel.Workbook();
              const readFileAsArrayBuffer = (file) => {
                return new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onerror = () => reject(new Error('Failed to read file'));
                  reader.onload = () => resolve(reader.result);
                  reader.readAsArrayBuffer(file);
                });
              };

              this.loading = true;
              const results = [];

              try {
                const buffer = await readFileAsArrayBuffer(this.excelFile);
                const wb = await workbook.xlsx.load(buffer);

                const excelItems = [];
                wb.eachSheet((sheet) => {
                  const idToTableItem = {};
                  sheet.eachRow((row, rowIndex) => {
                    if (rowIndex === 1) {
                      // header row
                      row.values.forEach((val, idx) => {
                        if (idx > 0 && val != null) idToTableItem[idx] = String(val).trim();
                      });
                    } else {
                      const excelItem = {};
                      row.values.forEach((val, idx) => {
                        if (idx > 0 && idToTableItem[idx]) {
                          excelItem[idToTableItem[idx]] = val;
                        }
                      });
                      if (!excelItem || !excelItem.sku) {
                        this.$store.commit('displaySnackbar', `Skipped SKU ${excelItem.sku} or invalid quantity`);
                        return;
                      }
                      excelItems.push(excelItem);
                    }
                  });
                });

                for (const excelItem of excelItems) {
                  const sku = String(excelItem.sku).trim();
                  const qtyRaw = excelItem.quantity;
                  const qty = Number(qtyRaw);
                  const rawQty = excelItem.quantity;


                  if (rawQty === null || rawQty === undefined || String(rawQty).trim() === '' || !Number.isFinite(qty) || qty <= 0) {
                    const skuDisplay = sku || '(no sku)';
                    results.push({ sku: skuDisplay, ok: false, msg: 'invalid quantity' });
                    this.$store.commit('displaySnackbar', `Skipped SKU ${skuDisplay}: invalid quantity`);
                    continue;
                  }

                  try {
                    const getRes = await axios.get(process.env.API_URL + '/items?client=' + this.receivingOrder.client_id + '&&sku=' + excelItem['sku']);

                    if (!Array.isArray(getRes.data) || getRes.data.length === 0) {
                      results.push({ sku, ok: false, msg: 'item not found' });
                      this.$store.commit('displaySnackbar', `ERROR: Item not found for SKU ${sku}`);
                      continue;
                    }

                    const itemId = getRes.data[0].id;
                    const body = {
                      item_id: Number(itemId),
                      quantity: qty,
                      serial: excelItem.serial
                    };
  console.log(body);
                    await axios.post(process.env.API_URL + '/receivingorders/' + this.receivingOrder.id + '/items', body);
                    results.push({ sku, ok: true });
                    this.$store.commit('displaySnackbar', `Create item ${itemId} successful`);
                    await this.updateDataTable();
                  } catch (err) {
                    const msg = err.response.data.error || err.message || 'Unknown error';
                    results.push({ sku, ok: false, msg });
                    this.$store.commit('displaySnackbar', `ERROR processing SKU ${sku}: ${msg}`);
                  }
                }

                const successCount = results.filter(r => r.ok).length;
                const failCount = results.length - successCount;
                this.$store.commit('displaySnackbar', `Import complete: ${successCount} succeeded, ${failCount} failed, please check the sku, quantity, name, can not be null.`);
              } catch (err) {
                this.$store.commit('displaySnackbar', `ERROR reading file: ${err.message || err}`);
              } finally {
                this.loading = false;
              }
          },
          getExcel(){
                axios.get(process.env.API_URL + '/items?client=' + this.receivingOrder.client_id)
                  .then((response) => {
                    console.log(response.data);
                    if (!this.receivingOrder.client_name){
                      this.receivingOrder.client_name = response.data[0].client_name;
                    }
                    const workbook = new Excel.Workbook();
                    const worksheet = workbook.addWorksheet("TemplateItems");

                    worksheet.columns = [
                      {header: 'sku', key: 'sku', width: 30},
                      {header: 'serial', key: 'serial', width: 10},
                      {header: 'name', key: 'name', width: 30},
                      {header: 'quantity', key: 'quantity', width: 10}
                    ];

                    response.data.forEach( focusedIem => {
                      worksheet.addRow({
                        sku: focusedIem.sku,
                        serial: focusedIem.serial,
                        name: focusedIem.name,
                        quantity: focusedIem.quantity
                      });
                    });

                    workbook.xlsx.writeBuffer()
                      .then( data => {
                        const blob = new Blob( [data], { type: 'application/octet-stream'} );
                        saveAs( blob, "Template Items " + this.receivingOrder.client_name +".xlsx");
                      });
                  })
                  .catch((response) => {
                    console.log(response);
                    this.$store.commit('displaySnackbar', 'ERROR ' + response);
                  })
              },
        },
        asyncComputed: {
            async GetReceivingOrderItems() {
                if (this.reload || !this.reload) {
                    if (this.receivingOrder.id !== 0){
                        this.loading = true;
                        return await axios.get(process.env.API_URL + '/receivingorders/' + this.receivingOrder.id + '/items')
                            .then((response) => {
                                if (response.status === 200) {
                                    this.loading = false;
                                    return response.data;
                                } else {
                                    this.loading = false;
                                    return [];
                                }
                            })
                            .catch((error) => {
                                this.loading = false;
                                return [];
                            });
                    }
                }
            },
        },
    }
</script>

<style scoped>
  .client-name {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin-top: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/components/util/Inventory/CreateReceiveOrder.vue